export default "__VITE_ASSET__ae98JHHF__"